import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { DataTableFilterMeta } from 'primereact/datatable';
import { useMemo } from 'react';

export type PositionAssignmentFilterMeta = DataTableFilterMeta;

export const usePositionAssignmentFilters = (params: {
  startDate: Date | null;
  endDate: Date | null;
  flightNumber?: string | null;
  departureAirport?: string | null;
  arrivalAirport?: string | null;
  aircraftRegistration?: string | null;
  purserEmployeeId?: string | null;
}) =>
  useMemo<PositionAssignmentFilterMeta>(
    () => ({
      global: {
        value: null,
        matchMode: FilterMatchMode.CONTAINS,
      },

      flightNumber: {
        operator: FilterOperator.AND,
        constraints: [{ value: params.flightNumber ?? null, matchMode: FilterMatchMode.CONTAINS }],
      },

      departureAirport: {
        operator: FilterOperator.AND,
        constraints: [
          { value: params.departureAirport ?? null, matchMode: FilterMatchMode.CONTAINS },
        ],
      },

      arrivalAirport: {
        operator: FilterOperator.AND,
        constraints: [
          { value: params.arrivalAirport ?? null, matchMode: FilterMatchMode.CONTAINS },
        ],
      },

      aircraftRegistration: {
        operator: FilterOperator.AND,
        constraints: [
          { value: params.aircraftRegistration ?? null, matchMode: FilterMatchMode.CONTAINS },
        ],
      },

      purserEmployeeId: {
        operator: FilterOperator.AND,
        constraints: [
          { value: params.purserEmployeeId ?? null, matchMode: FilterMatchMode.CONTAINS },
        ],
      },

      flightDate: {
        operator: FilterOperator.AND,
        constraints: [
          {
            value: [
              params.startDate ? new Date(params.startDate) : null,
              params.endDate ? new Date(params.endDate) : null,
            ],
            matchMode: FilterMatchMode.BETWEEN,
          },
        ],
      },
    }),
    [params],
  );
